import Vue from 'vue'
import store from '../../store/index'

// 第一次打开新标签页、刷新页面也算第一次打开
if (!window.name) {
  systemChange(window.location.pathname)
}

// 监听浏览器旧标签页之间切换
document.addEventListener('visibilitychange', function () { // 浏览器切换事件
  if (document.visibilityState == 'visible') { // 回到当前tab标签
    systemChange(window.location.pathname)
  }
})

function systemChange (urlPath) {
  const tagPageName = urlPath.split('/')[2] // 获取后台标签名称
  let labelTye = -1
  let token = null
  // switch tagPageName {
  //   //站点后台
  //   case "site":
  //   break;
  //   //应用后台
  //   case "apply":
  //   break;
  // }
}



// WEBPACK FOOTER //
// ./src/assets/js/tabSwitchListener.js